module.exports = __webpack_public_path__ + "img/66_3.2ffa68a3.png";